import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';
import {
  isYes,
  isNo,
} from '../../../../../../../components/loan_application/utils/helpers';

const { pgFiledTaxes1YearAgo, pgFiledTaxes2YearsAgo, pgFiledTaxes3YearsAgo } =
  loanFormModel.formField;

class HasPgFiledTaxesYearsAgo implements Rule {
  private years = 1; // 1 year ago
  private principalId: any;
  private answer: 'Yes' | 'No' | null = 'Yes';

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  private getPrincipal(data: Partial<ApplicationFormValues>) {
    return data.principals?.find(
      (principal) => principal.id === this.principalId
    );
  }

  public setYears(years: number) {
    this.years = years;
    return this;
  }

  public setAnswer(answer: 'Yes' | 'No' | null) {
    this.answer = answer;
    return this;
  }

  private getPgFiledTaxesYearsAgoField() {
    switch (this.years) {
      case 1:
        return pgFiledTaxes1YearAgo;
      case 2:
        return pgFiledTaxes2YearsAgo;
      case 3:
        return pgFiledTaxes3YearsAgo;
    }
    return pgFiledTaxes1YearAgo;
  }

  private isExpectedAnswer(answer: 'Yes' | 'No' | null) {
    switch (this.answer) {
      case 'Yes':
        return isYes(answer);
      case 'No':
        return isNo(answer);
    }
    return false;
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const principal = this.getPrincipal(application);
    const pgFiledTaxesYearsAgoValue =
      principal?.[this.getPgFiledTaxesYearsAgoField().name];
    return (
      pgFiledTaxesYearsAgoValue !== null &&
      pgFiledTaxesYearsAgoValue !== undefined &&
      this.isExpectedAnswer(pgFiledTaxesYearsAgoValue)
    );
  }
}

export default new HasPgFiledTaxesYearsAgo();
